module.exports = __webpack_public_path__ + "img/hot_line_segednyujtas-pop_up.89b22a3f.png";